import { render, staticRenderFns } from "./LoginFthh.vue?vue&type=template&id=4b067ba3&scoped=true&"
import script from "./LoginFthh.vue?vue&type=script&lang=js&"
export * from "./LoginFthh.vue?vue&type=script&lang=js&"
import style0 from "./LoginFthh.vue?vue&type=style&index=0&id=4b067ba3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b067ba3",
  null
  
)

export default component.exports